module.exports = __webpack_public_path__ + "media/Video 86.7087618f.mp4";